// 视图组件
const view = {
  tabs: () => import('@/layouts/tabs'),
  blank: () => import('@/layouts/BlankView'),
  page: () => import('@/layouts/PageView')
}

// 路由组件注册
const routerMap = {
  login: {
    authority: '*',
    path: '/login',
    component: () => import('@/pages/login')
  },
  root: {
    path: '/',
    name: '首页',
    redirect: '/login',
    component: view.tabs
  },
  dashboard: {
    name: 'Dashboard',
    component: view.blank
  },
  workplace: {
    name: '工作台',
    component: () => import('@/pages/dashboard/workplace')
  },
  analysis: {
    name: '分析页',
    component: () => import('@/pages/dashboard/analysis')
  },
  form: {
    name: '表单页',
    icon: 'form',
    component: view.page
  },
  basicForm: {
    path: 'basic',
    name: '基础表单',
    component: () => import('@/pages/form/basic')
  },
  stepForm: {
    path: 'step',
    name: '分步表单',
    component: () => import('@/pages/form/step')
  },
  advanceForm: {
    path: 'advance',
    name: '高级表单',
    component: () => import('@/pages/form/advance')
  },
  list: {
    name: '列表页',
    icon: 'table',
    component: view.page
  },
  queryList: {
    path: 'query',
    name: '查询表格',
    component: () => import('@/pages/list/QueryList')
  },
  primaryList: {
    path: 'primary',
    name: '标准列表',
    component: () => import('@/pages/list/StandardList')
  },
  cardList: {
    path: 'card',
    name: '卡片列表',
    component: () => import('@/pages/list/CardList')
  },
  searchList: {
    path: 'search',
    name: '搜索列表',
    component: () => import('@/pages/list/search/SearchLayout')
  },
  article: {
    name: '文章',
    component: () => import('@/pages/list/search/ArticleList')
  },
  application: {
    name: '应用',
    component: () => import('@/pages/list/search/ApplicationList')
  },
  project: {
    name: '项目',
    component: () => import('@/pages/list/search/ProjectList')
  },
  details: {
    name: '详情页',
    icon: 'profile',
    component: view.blank
  },
  basicDetails: {
    path: 'basic',
    name: '基础详情页',
    component: () => import('@/pages/detail/BasicDetail')
  },
  advanceDetails: {
    path: 'advance',
    name: '高级详情页',
    component: () => import('@/pages/detail/AdvancedDetail')
  },
  result: {
    name: '结果页',
    icon: 'check-circle-o',
    component: view.page
  },
  success: {
    name: '成功',
    component: () => import('@/pages/result/Success')
  },
  error: {
    name: '失败',
    component: () => import('@/pages/result/Error')
  },
  exception: {
    name: '异常页',
    icon: 'warning',
    component: view.blank
  },
  exp403: {
    authority: '*',
    name: 'exp403',
    path: '403',
    component: () => import('@/pages/exception/403')
  },
  exp404: {
    name: 'exp404',
    path: '404',
    component: () => import('@/pages/exception/404')
  },
  exp500: {
    name: 'exp500',
    path: '500',
    component: () => import('@/pages/exception/500')
  },
  components: {
    name: '小组件',
    icon: 'appstore-o',
    component: view.page
  },
  taskCard: {
    name: '任务卡片',
    component: () => import('@/pages/components/TaskCard')
  },
  palette: {
    name: '颜色复选框',
    component: () => import('@/pages/components/Palette')
  },
  '离校管理': {
    path: 'leaving',
    name: '离校管理',
    icon: 'import',
    component: view.page
  },
  // 扩展组件
  "离校管理 ": {
    path: 'leaving-management',
    meta:{
      authority:{
        permission:'leaving'
      }
    },
    name: '离校管理',
    component: () => import('@/pages/leaving-management/SchoolLeavingManagement'),
  },
  "材料认领确认管理": {
    path: 'material-science-management',
    name: '材料认领确认管理',
    component: () => import('@/pages/leaving-management/MaterialScienceManagement'),
  },
  "客户端管理": {
    path: 'client',
    name: '客户端管理',
    icon: 'mobile',
    component: view.page
  },
  "轮播图":   {
    path: 'banner-management',
    name: '轮播图',
    component: () => import('@/pages/client-management/BannerManagement'),
  },
  "通知公告":  {
    path: 'notice-management',
    name: '通知公告',
    component: () => import('@/pages/client-management/NoticeManagement'),
  },
  "离校设置": {
    path: 'settings',
    name: '离校设置',
    icon: 'disconnect',
    component: view.page
  },
  '事项管理':{
    path: 'event-management',
    name: '事项管理',
    component: () => import('@/pages/settings/EventManagement'),
  },
  '消息模板':{
    path: 'msg-template',
    name: '消息模板',
    component: () => import('@/pages/settings/MsgTemplate'),
  },
  '毕业名单':{
    path: 'graduation-list',
    name: '毕业名单',
    component: () => import('@/pages/settings/GraduationList'),
  },
  '材料认领管理':{
    path: 'material-science-management',
    name: '材料认领管理',
    component: () => import('@/pages/settings/MaterialScienceManagement'),
  },
  '材料认领管理-明细':{
    path: 'material-science',
    name: '材料认领管理',
    meta:{invisible:true},
    component: () => import('@/pages/settings/sub/CreateMaterialScience'),
  },
  '毕业名单-明细':{
    path: 'graduation-list-sub',
    meta:{invisible:true},
    name: '毕业名单',
    component: () => import('@/pages/settings/sub/SubGraduationList'),
  },
  "系统设置": {
    path: 'sys',
    name: '系统设置',
    icon: 'setting',
    component: view.page
  },
  '组织机构':{
    path: 'organization',
    name: '组织机构',
    component: () => import('@/pages/sys/Organization'),
  },
  '权限管理':{
    path: 'role',
    name: '权限管理',
    component: () => import('@/pages/sys/Role'),
  },
  '系统日志':{
    path: 'log',
    meta:{invisible:true},
    name: '系统日志',
    component: () => import('@/pages/sys/Log'),
  },
  '数据字典':{
    path: 'dict',
    name: '数据字典',
    component: () => import('@/pages/sys/Dict'),
  },
  '数据大屏':{
    name: '数据大屏',
    path: 'big-screen',
    meta: {
      icon: 'bar-chart',
    },
    component: () => import('@/pages/big-screen/BigScreen'),
  },
  'home':{
    name: '首页',
    path: 'home',
    meta: {
      invisible:true
    },
    component: () => import('@/pages/index/Index'),
  }
}
export default routerMap

